import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[fixarHeader]'
})
export class FixarHeaderDirective {
  private headerInitialState: CSSStyleDeclaration;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const header = this.el.nativeElement;

    // Salva o estado inicial do header
    if (!this.headerInitialState) {
      this.headerInitialState = window.getComputedStyle(header);
    }

    if (scrollOffset > header.offsetTop) {
      this.renderer.setStyle(header, 'position', 'fixed');
      this.renderer.setStyle(header, 'top', '0');
      console.log('scrollOffset', scrollOffset);
      console.log('header.offsetTop', header.offsetTop); 
    } else {
      // Verifica se o scroll está acima da linha de dobra
      if (scrollOffset <= header.offsetTop) {
        // Retorna ao estado inicial    
        this.renderer.setStyle(header, 'position', 'absolute');
        this.renderer.removeStyle(header, 'top');
      }
    }
  }
}